//import firebase from 'firebase/app';
import { initializeApp } from 'firebase/app';
//import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

//import 'firebase/firestore';
//import 'firebase/storage';
import { getStorage } from 'firebase/storage';

/*const firebaseConfig = {
  apiKey: "AIzaSyD5CdhwlU7WpVcuAuqjxBQX8KuallsOAhM",
  authDomain: "sound-chat-526d0.firebaseapp.com",
  databaseURL: "https://sound-chat-526d0.firebaseio.com",
  projectId: "sound-chat-526d0",
  storageBucket: "sound-chat-526d0.appspot.com",
  messagingSenderId: "590691236668",
  appId: "1:590691236668:web:27270667fafdd7af01fc39"
};*/

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCVt0spGmPRSbEoTOV2BTsS7ePNbd76bBg",
  authDomain: "xhlpme-firebase1.firebaseapp.com",
  projectId: "xhlpme-firebase1",
  storageBucket: "xhlpme-firebase1.firebasestorage.app",
  messagingSenderId: "697971552487",
  appId: "1:697971552487:web:60642eb61591211d68b242",
  measurementId: "G-DLXKRX8KDR"
};

//export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseApp = initializeApp(firebaseConfig);

//export const firestoreDb = firebase.firestore();
export const firestoreDb = getFirestore(firebaseApp);

//export const cloudStorage = firebase.storage();
export const cloudStorage = getStorage(firebaseApp);